import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { User } from '../_models/user';
import { AuthenticationService } from './authentication.service';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root',
})
export class AssetService {
  currentUser: User | null;
  currentTenantId = '';
  public assetTypes$: BehaviorSubject<any[]> = new BehaviorSubject(undefined);
  public assetCount$: BehaviorSubject<any> = new BehaviorSubject(0);
  public assets$: BehaviorSubject<any> = new BehaviorSubject(undefined);
  public assetsList$ = this.assets$.asObservable();

  constructor(
    private httpClient: HttpClient,
    private authenticationService: AuthenticationService,
    private dataService: DataService
  ) {
    this.authenticationService.currentAccountValue.subscribe(user => {
      this.currentUser = user;
      this.currentTenantId = user?.tenantId;
    });
  }

  createAssetType(model: { name: string; icon?: string; labels?: string[]; description?: string; builtInIdentifier?: string }) {
    return this.dataService.createAssetModel(model).pipe(
      map((res: any) => {
        if (res?.assetModel?._id) return res.assetModel;
        if (res?.data?._id) return res.data;
        if (res?._id) return res;
        throw new Error('Invalid response from createAssetModel: no _id found');
      }),
      tap((created: any) => {
        const current = this.assetTypes$.getValue() || [];
        this.assetTypes$.next([...current, created]);
      })
    );
  }

  fetchAssets() {
    this.httpClient
      .get(
        `${environment.apiPrefix}${this.currentTenantId}${environment.apiSuffix}/assets?includeLastSeen=true`
      )
      .subscribe((assets: any[]) => {
        if (assets) {
          this.assets$.next(assets);
          this.assetCount$.next(assets.length);
        }
      });
  }

  fetchAssetTypes() {
    this.httpClient
      .get(
        `${environment.apiPrefix}${this.currentTenantId}${environment.apiSuffix}/asset-models`
      )
      .subscribe((assetTypes: any[]) => {
        if (assetTypes) {
          this.assetTypes$.next(assetTypes);
        }
      });
  }
}
